// @ts-nocheck
/* eslint-disable */
/**
 * Generated by orval 🍺
 * Do not edit manually.
 * SUREnet aanvragen-public API
 * OpenAPI spec version: 1
 */

export type AanvragenDomainEntitiesOntvangerDirectePost =
  (typeof AanvragenDomainEntitiesOntvangerDirectePost)[keyof typeof AanvragenDomainEntitiesOntvangerDirectePost];

export const AanvragenDomainEntitiesOntvangerDirectePost = {
  Relatie: 'Relatie',
  Adviseur: 'Adviseur',
  Beide: 'Beide',
} as const;
